import React, { useState, useEffect } from 'react'
import { useAppSelector, useAppDispatch } from '../../app/hooks'
import { Layout, Button, Radio, message, Modal } from 'antd'
import { fetchPermission, updatePermission } from '../../actions/team'
import { setPaymentVisible } from '../../actions/main'
import sensors from '../../utils/sensors'
import * as Sentry from '../../utils/sentryUtils'
import vipPrivilegeImage from '../../images/vvip_privilege.png'
import CONFIG from '../../constants/config'

import PageHeader from '@/components/PageHeader'
const { Content } = Layout

function Authority() {
  const dispatch = useAppDispatch()
  const userID = useAppSelector((state) => state.main.user?.user_id)
  const groupID = useAppSelector((state) => state.group.groupId)
  const organization = useAppSelector(
    (state) => state.organization.organization
  )
  const group = useAppSelector((state) => state.group)

  const [permissions, setPermissions] = useState({
    favoritePermission: 2,
    viewPermission: 1,
    deletePermission: 1
  })

  useEffect(() => {
    dispatch(
      fetchPermission({
        userID,
        groupID
      })
    )
      .then((data) => {
        setPermissions({
          favoritePermission: data.favoritePermission,
          viewPermission: data.viewPermission,
          deletePermission: data.deletePermission
        })
      })
      .catch(Sentry.capturePromiseException)
  }, [dispatch, userID, groupID])

  const handleSavePerm = () => {
    sensors.track('web_workgroup_authority_set', {
      photoViewPermission:
        permissions.viewPermission === 0 ? 'allMember' : 'onlyManager',
      photoDeletPermission:
        permissions.deletePermission === 1
          ? 'oneHour'
          : permissions.deletePermission === 0
            ? '24Hours'
            : 'anyTime'
    })

    if ([1, 2].includes(permissions.viewPermission)) {
      const isVip = group.isVip
      const isSVip = isVip && group.vipInfo?.vip_kind === CONFIG.VIP_KIND.SVIP
      const isVVip = isVip && group.vipInfo?.vip_kind === CONFIG.VIP_KIND.VVIP
      if (!isSVip && !isVVip) {
        dispatch(
          setPaymentVisible(
            true,
            'groupPhotoViewPermission',
            CONFIG.VIP_KIND.VVIP
          )
        )
        return
      }
    }

    if (
      permissions.viewPermission === 2 &&
      organization.children.length === 0
    ) {
      Modal.warning({
        title: '提示',
        content: '请先在部门管理添加子部门'
      })
      return false
    }

    dispatch(
      updatePermission({
        userID,
        groupID,
        ...permissions
      })
    )
      .then(() => {
        message.success('修改成功')
      })
      .catch(Sentry.capturePromiseException)
  }

  return (
    <Layout className="Authority">
      <PageHeader className="Header" ghost={true} title="权限管理" />
      <Content className="content">
        <h3 style={{ display: 'flex', alignItems: 'center' }}>
          普通员工照片查看权限
          <img
            style={{
              width: '104px',
              height: '24px',
              marginLeft: '6px'
            }}
            src={vipPrivilegeImage}
          />
        </h3>
        <Radio.Group
          value={permissions.viewPermission}
          onChange={(e) =>
            setPermissions({ ...permissions, viewPermission: e.target.value })
          }
        >
          <Radio className="radio" value={0}>
            全团队
          </Radio>
          <Radio className="radio" value={2}>
            所在部门和下级部门
          </Radio>
          <Radio className="radio" value={1}>
            仅自己
          </Radio>
        </Radio.Group>
        <br />
        <br />
        <h3>普通成员删除照片时限（管理员随时可删）</h3>
        <Radio.Group
          value={permissions.deletePermission}
          onChange={(e) =>
            setPermissions({ ...permissions, deletePermission: e.target.value })
          }
        >
          <Radio className="radio" value={1}>
            同步1小时内
          </Radio>
          <Radio className="radio" value={0}>
            同步24小时内
          </Radio>
          <Radio className="radio" value={2}>
            随时
          </Radio>
        </Radio.Group>
        <br />
        <Button
          style={{ marginTop: '40px' }}
          type="primary"
          onClick={handleSavePerm}
        >
          保存
        </Button>
      </Content>
    </Layout>
  )
}

export default Authority
